import { render, staticRenderFns } from "./BostonForgetPassword.vue?vue&type=template&id=6f023376&scoped=true"
import script from "./BostonForgetPassword.vue?vue&type=script&lang=js"
export * from "./BostonForgetPassword.vue?vue&type=script&lang=js"
import style0 from "./BostonForgetPassword.vue?vue&type=style&index=0&id=6f023376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f023376",
  null
  
)

export default component.exports